'use client';

import { useMemo } from 'react';
import { BigNum, PRICE_PRECISION_EXP } from '@velocity-exchange/sdk';
import NumberDisplay from 'src/components/NumberDisplay/NumberDisplay';
import useDriftAccountStore from 'src/stores/useDriftAccountsStore';
import { BalanceRowData } from './types';
import { cm } from 'src/utils/classNames';

interface LiqPriceCellProps {
	row: BalanceRowData;
}

export function LiqPriceCell({ row }: LiqPriceCellProps) {
	const { spotMarketIndex } = row;

	const currentUserClient = useDriftAccountStore(
		(s) => s.getCurrentUserAccount()?.client
	);

	const liqPrice = useMemo(() => {
		const liquidationPrice =
			currentUserClient?.spotLiquidationPrice(spotMarketIndex);
		return BigNum.from(liquidationPrice ?? 0, PRICE_PRECISION_EXP);
	}, [currentUserClient, spotMarketIndex]);

	const isValid = liqPrice.gtZero();

	return (
		<div className={cm('flex items-center', !isValid && 'text-text-disabled')}>
			<NumberDisplay
				value={liqPrice}
				type="currency"
				displayOverride={isValid ? undefined : '-'}
				isAccountValueToHide
			/>
		</div>
	);
}
